import { render } from "./ObstetricHistoryTab.vue?vue&type=template&id=230e3340&scoped=true"
import script from "./ObstetricHistoryTab.vue?vue&type=script&lang=js"
export * from "./ObstetricHistoryTab.vue?vue&type=script&lang=js"

import "./ObstetricHistoryTab.vue?vue&type=style&index=0&id=230e3340&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230e3340"]])

export default __exports__